import React from "react";

/**
 * Ayobell brand mark.
 *  variant="mark"     → square logo only (for tight nav/avatar slots)
 *  variant="stacked"  → mark + product name + tagline (login/hero)
 *  variant="inline"   → mark + name on a single row (sidebar/top nav)
 */
export const BRAND = {
  name: "Ayobell Care",
  fullName: "Ayobell : The Digital Care Management Platform",
  tagline: "Technology that Cares",
  poweredBy: "Powered by TechSpace Solutions Ltd",
};

export default function Brand({ variant = "inline", theme = "dark", className = "" }) {
  const textColor = theme === "dark" ? "text-slate-100" : "text-slate-900";
  const subColor = theme === "dark" ? "text-slate-400" : "text-slate-500";

  if (variant === "mark") {
    return (
      <img
        src="/brand/icon-192.png"
        alt="Ayobell"
        data-testid="brand-mark"
        className={`object-contain ${className}`}
      />
    );
  }

  if (variant === "stacked") {
    return (
      <div className={`flex items-center gap-3 ${className}`} data-testid="brand-stacked">
        <img src="/brand/icon-128.png" alt="Ayobell" className="w-11 h-11 object-contain shrink-0" />
        <div>
          <div className={`font-heading font-semibold text-lg leading-tight ${textColor}`}>{BRAND.name}</div>
          <div className={`text-[10px] uppercase tracking-widest ${subColor}`}>{BRAND.tagline}</div>
        </div>
      </div>
    );
  }

  // inline
  return (
    <div className={`flex items-center gap-2 ${className}`} data-testid="brand-inline">
      <img src="/brand/icon-64.png" alt="Ayobell" className="w-8 h-8 object-contain shrink-0" />
      <div className="min-w-0">
        <div className={`font-heading font-semibold tracking-tight text-sm truncate ${textColor}`}>{BRAND.name}</div>
        <div className={`text-[10px] uppercase tracking-widest ${subColor}`}>{BRAND.tagline}</div>
      </div>
    </div>
  );
}

export function PoweredBy({ theme = "dark", className = "" }) {
  const color = theme === "dark" ? "text-slate-500" : "text-slate-500";
  return (
    <div data-testid="powered-by" className={`text-[10px] uppercase tracking-widest ${color} ${className}`}>
      {BRAND.poweredBy}
    </div>
  );
}
